/* STRIPD theme scripts */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function moneyFormat() {
    var el = document.getElementById('shopMoneyFormat');
    try { return el ? JSON.parse(el.textContent) : '${{amount}}'; } catch (e) { return '${{amount}}'; }
  }
  function formatMoney(cents) {
    var fmt = moneyFormat();
    var n = (cents / 100);
    function delim(num, dec, thou, sep) {
      var parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return delim(n, 0, ',', '.');
        case 'amount_with_comma_separator': return delim(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return delim(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return delim(n, 2, "'", '.');
        default: return delim(n, 2, ',', '.');
      }
    });
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  function drawerEls() {
    return { d: document.getElementById('cartDrawer'), o: document.getElementById('cartOverlay') };
  }
  function openCart() {
    var e = drawerEls(); if (!e.d) return;
    e.d.classList.add('open'); e.o.classList.add('open'); e.d.setAttribute('aria-hidden', 'false');
    var c = e.d.querySelector('.cart-close'); if (c) c.focus();
  }
  function closeCart() {
    var e = drawerEls(); if (!e.d) return;
    e.d.classList.remove('open'); e.o.classList.remove('open'); e.d.setAttribute('aria-hidden', 'true');
  }

  function renderCart(cart) {
    var badge = document.getElementById('cartBadge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
    var total = document.getElementById('cartTotal');
    if (total) total.textContent = formatMoney(cart.total_price);
    var items = document.getElementById('cartItems');
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<div class="cart-empty">Your cart is empty.</div>';
      return;
    }
    items.innerHTML = cart.items.map(function (i, idx) {
      var variant = i.variant_title && i.variant_title !== 'Default Title' ? ' · ' + esc(i.variant_title) : '';
      return '<div class="cart-item">' +
        '<div>' +
          '<a class="cart-item-name" href="' + esc(i.url) + '" style="color:inherit;text-decoration:none;display:block">' + esc(i.product_title) + variant + '</a>' +
          '<div class="cart-item-price">' + formatMoney(i.final_line_price) + '</div>' +
          '<div class="cart-item-qty">' +
            '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button type="button" data-line="' + (idx + 1) + '" data-qty="' + (i.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="cart-item-remove" data-line="' + (idx + 1) + '" data-qty="0" aria-label="Remove ' + esc(i.product_title) + '">&#10005;</button>' +
      '</div>';
    }).join('');
  }

  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }

  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-cart-toggle]');
    if (t) {
      e.preventDefault();
      var d = document.getElementById('cartDrawer');
      if (d && d.classList.contains('open')) closeCart(); else { fetchCart(); openCart(); }
      return;
    }
    var q = e.target.closest('#cartItems [data-line]');
    if (q) changeLine(parseInt(q.dataset.line, 10), Math.max(0, parseInt(q.dataset.qty, 10)));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (data) { return { ok: r.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add to cart'); return; }
      toast('Added to cart');
      if (btn) { btn.innerHTML = 'Added &#10003;'; btn.classList.add('added'); }
      fetchCart().then(openCart);
      setTimeout(function () { if (btn) { btn.innerHTML = label; btn.classList.remove('added'); } }, 1800);
    }).catch(function () {
      form.removeAttribute('data-add-to-cart');
      form.submit();
    }).finally(function () { if (btn) btn.disabled = false; });
  });

  function closeMenu() {
    var m = document.getElementById('mobileMenu');
    var b = document.querySelector('.hamburger');
    if (m) m.classList.remove('open');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.hamburger');
    var m = document.getElementById('mobileMenu');
    if (b && m) {
      var open = m.classList.toggle('open');
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (e.target.closest('#mobileMenu a')) closeMenu();
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-variant-input]');
    if (!input) return;
    var form = input.closest('form');
    var price = input.dataset.price ? formatMoney(parseInt(input.dataset.price, 10)) : '';
    var unit = input.dataset.unit || '';
    document.querySelectorAll('[data-pp-price]').forEach(function (el) {
      el.innerHTML = price + (unit ? ' <span>/ ' + esc(unit) + '</span>' : '');
    });
    document.querySelectorAll('[data-pp-add-price]').forEach(function (el) { el.textContent = price; });
    var available = input.dataset.available === 'true';
    if (form) {
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = !available;
    }
    var sticky = document.querySelector('#ppSticky input[name="id"]');
    if (sticky) sticky.value = input.value;
  });

  function initFlow(flow) {
    var steps = flow.querySelectorAll('.flow-step');
    var scenes = flow.querySelectorAll('.flow-scene');
    var dotsEl = flow.querySelector('.flow-progress');
    var caption = flow.querySelector('.flow-caption');
    var timerEl = flow.querySelector('.flow-timer');
    var nextBtn = flow.querySelector('[data-flow-next]');
    var prevBtn = flow.querySelector('[data-flow-prev]');
    var n = scenes.length, step = 0, autoplay = null, timerInt = null;
    for (var i = 0; i < n; i++) {
      var d = document.createElement('span');
      d.className = 'flow-dot' + (i === 0 ? ' on' : '');
      dotsEl.appendChild(d);
    }
    function restartAnim(scene) {
      scene.querySelectorAll('[class*="anim-"]').forEach(function (el) {
        var c = el.getAttribute('class'); el.setAttribute('class', ''); void el.getBoundingClientRect(); el.setAttribute('class', c);
      });
    }
    function go(k, fromAuto) {
      if (!fromAuto) stop();
      step = Math.max(0, Math.min(n - 1, k));
      steps.forEach(function (b, i) { b.classList.toggle('active', i === step); b.setAttribute('aria-selected', i === step ? 'true' : 'false'); });
      scenes.forEach(function (s, i) { s.classList.toggle('active', i === step); if (i === step) restartAnim(s); });
      flow.querySelectorAll('.flow-dot').forEach(function (d, i) { d.classList.toggle('on', i === step); });
      if (caption) caption.textContent = scenes[step].dataset.caption || '';
      clearInterval(timerInt);
      if (timerEl && scenes[step].contains(timerEl)) {
        var t = 60; timerEl.textContent = t;
        timerInt = setInterval(function () { t = Math.max(0, t - 4); timerEl.textContent = t; if (t === 0) clearInterval(timerInt); }, 200);
      }
    }
    function stop() { clearInterval(autoplay); autoplay = null; if (nextBtn) nextBtn.textContent = step >= n - 1 ? 'Replay' : 'Play'; }
    function start() {
      if (nextBtn) nextBtn.textContent = 'Pause';
      if (step === 0) go(0, true);
      autoplay = setInterval(function () { if (step >= n - 1) { stop(); return; } go(step + 1, true); }, 3200);
    }
    steps.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      if (autoplay) { stop(); return; }
      if (step >= n - 1) go(0);
      start();
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(step - 1); });
  }

  function init() {
    document.querySelectorAll('[data-flow]').forEach(initFlow);
    fetchCart().catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
